export const localeFallbacks = {"de":"en","de_AT":"de","de_DE":"de","de_CH":"de","en":null,"es":"en","pl":"en","cs":"en","nl":"en"};
